import { effects } from 'redux-saga'

import { makeSelectClients } from 'internal-components/src/redux/modules/client'

import { selectClient } from '../../modules/signupEdit/actions'
import { selectEditSignupWithExternals } from '../../modules/signupEdit/selectors'

/**
 * Attempt to set an initial client/billing group selection.
 *
 * Logic:
 *
 * - 1client/1billing group = auto select
 *
 * TODO:
 * - 1 client, multiple billing groups - auto select most $/month ?
 * - multiple clients, only one with OWNER, one billing group - auto select
 * - multiple clients, multiple owners, multiple billing groups - highest spend?
 */
export default function* setInitialClient() {
  const state = yield effects.select()
  const signupWithExternals = yield effects.call(
    selectEditSignupWithExternals,
    state,
  )
  const user = state.authentication.get('user')

  if (
    !user ||
    !signupWithExternals.signup ||
    signupWithExternals.signup.clientId
  ) {
    return
  }

  const clientIds = user.relationships.map(rel => rel.client_id).toArray()
  const selector = yield effects.call(makeSelectClients)
  const clients = yield effects.call(selector, state, { clientIds })

  if (clients.size === 1) {
    const client = clients.first()

    if (client.billing_groups.size === 1) {
      yield effects.put.resolve(
        selectClient(client.id, client.billing_groups.first()),
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/setInitialClient.js